import React, { useContext, useEffect, useRef, useState } from "react";

import Container from "react-bootstrap/Container";
import { Nav, Modal, Button, Dropdown, Form } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "../AxiosInstance";
import { useAuth } from "../context/auth";
import { FaBell } from "react-icons/fa";
import {
  GoogleLogin,
  GoogleOAuthProvider,
  useGoogleLogin,
} from "@react-oauth/google";
import { motion, AnimatePresence } from "framer-motion";
import { Badge } from "antd";
import { NotificationContext } from "../context/NotificationContext";
import { BASE_URL } from "../config/BaseUrls";
import ChatProvider, { ChatState } from "../context/ChatProvider";
import { LanguageContext } from "../context/LanguageContext";
import { translateNotification } from "../utils/notificationTranslator";
import { trackEvent } from "../utils/googleAnalytics";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// import FacebookLogin from "react-facebook-login";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { BsQuestionCircleFill } from "react-icons/bs";
import { X, Mail, ChevronRight, EyeOff, Eye } from "lucide-react";

const PRIMARY = "#34c3c9";
const languages = [
  "english",
  "francais",
  "deutsch",
  "italiano",
  "español",
  "nihongo",
  "nederlands",
  "chinese",
];

// Lanuguage Change All Haeder
const headerHow = {
  english: {
    howText: `How it works`,
  },
  italiano: {
    howText: `Come funziona`,
  },
  deutsch: {
    howText: `So funktioniert es`,
  },
  español: {
    howText: `Cómo funciona`,
  },
  francais: {
    howText: `Comment ça fonctionne`,
  },
  nihongo: {
    howText: `使い方`,
  },
  nederlands: {
    howText: `Hoe het werkt`,
  },
  chinese: {
    howText: `工作原理`,
  },
};
const headerBR = {
  english: {
    BAndRText: `Books & Reviews`,
  },
  italiano: {
    BAndRText: `Libri & Recensioni`,
  },
  deutsch: {
    BAndRText: `Bücher & Rezensionen`,
  },
  español: {
    BAndRText: `Libros & Reseñas`,
  },
  francais: {
    BAndRText: `Livres & Critiques`,
  },
  nihongo: {
    BAndRText: `書籍とレビュー
`,
  },
  nederlands: {
    BAndRText: `Boeken & Recensies`,
  },
  chinese: {
    BAndRText: `图书与评论`,
  },
};
const headerlogin = {
  english: {
    loginText: `Log in/Sign in`,
    ChangeLg: `Change your language`,
  },
  italiano: {
    loginText: `Accedi/Registrati
`,
    ChangeLg: `Cambia la tua lingua`,
  },
  deutsch: {
    loginText: `Anmelden / Registrieren
`,
    ChangeLg: `Ändere deine Sprache`,
  },
  español: {
    loginText: `Iniciar sesión / Registrarse
`,
    ChangeLg: `Cambiar tu idioma`,
  },
  francais: {
    loginText: `Se connecter / S'inscrire
`,
    ChangeLg: `Changer votre langue`,
  },
  nihongo: {
    loginText: `ログイン
`,
    ChangeLg: `言語を変更する`,
  },
  nederlands: {
    loginText: `Inloggen/Aanmelden`,
    ChangeLg: `Wijzig je taal`,
  },
  chinese: {
    loginText: `登录/注册`,
    ChangeLg: `更改您的语言`,
  },
};

const headerCopy = {
  english: {
    cookieMessage:
      "We use cookies to operate the site, analyze traffic, and personalize content and ads.",
    acceptCookies: "Accept all",
    rejectCookies: "Reject",
    noNotifications: "No new notifications yet.",
    createAccountTitle: "Create an account",
    continueGoogle: "Continue with Google",
    continueFacebook: "Continue with Facebook",
    continueApple: "Continue with Apple",
    continueEmail: "Continue with E-mail",
    orText: "or",
    alreadyMemberQuestion: "Already a member?",
    loginCta: "Log in",
    signupTitle: "Sign up",
    signupSubtitle: "Create your account with email",
    emailLabel: "E-mail",
    nameLabel: "Name or nickname",
    passwordLabel: "Password",
    booksellerQuestion: "Are you a bookseller?",
    yesLabel: "Yes",
    noLabel: "No",
    storeNamePlaceholder: "Store's name",
    addressPlaceholder: "Address",
    signupAgreementPrefix: "By signing up, you agree to our",
    signupAgreementAnd: "and",
    termsLinkText: "Terms of use",
    privacyLinkText: "Privacy Policy",
    cookiesLinkText: "Cookie Policy",
    signupButtonText: "Sign up",
    alreadyHaveAccount: "Already have an account?",
    loginLinkText: "Log in",
    keepSignedIn: "Keep me signed in",
    forgotPassword: "Forgot password?",
    forgotPasswordTitle: "Forgot password?",
    forgotPasswordSubtitle:
      "Enter the email associated with your account. We'll send you a secure link to reset your password.",
    resetPasswordButton: "Reset password",
    passwordGuidelines:
      "Please create a password with at least 10 characters, avoid common words, and do not reuse passwords.",
    newPasswordLabel: "New Password",
    confirmNewPasswordLabel: "Confirm New Password",
    submitButton: "Submit",
    tooltipPassword:
      "At least 8 characters, uppercase letters (A–Z), lowercase letters (a–z), numbers (0–9), and special characters (e.g., !, @, #, $, %, ^, &).",
    invalidEmail: "Please enter a valid email address",
    agreeTermsError:
      "Please agree to the terms and conditions before signing up.",
    enterEmailError: "Please enter your email",
    passwordLengthError: "Password must be at least 8 characters.",
    passwordUppercaseError:
      "Password must include at least one uppercase letter (A–Z).",
    passwordLowercaseError:
      "Password must include at least one lowercase letter (a–z).",
    passwordNumberError:
      "Password must include at least one number (0–9).",
    passwordSpecialError:
      "Password must include at least one special character (!@#$%^&*).",
    passwordMismatchError: "Passwords do not match.",
    passwordMinLengthReset: "Password must be at least 8 characters long.",
    resetPasswordTitle: "Reset your password",
    forgotPasswordHelper:
      "Enter the email associated with your account. We'll send you a secure link to reset your password.",
  },
  italiano: {
    cookieMessage:
      "Utilizziamo i cookie per far funzionare il sito, analizzare il traffico e personalizzare contenuti e annunci.",
    acceptCookies: "Accetta tutto",
    rejectCookies: "Rifiuta",
    noNotifications: "Nessuna nuova notifica.",
    createAccountTitle: "Crea un account",
    continueGoogle: "Continua con Google",
    continueFacebook: "Continua con Facebook",
    continueApple: "Continua con Apple",
    continueEmail: "Continua con e-mail",
    orText: "oppure",
    alreadyMemberQuestion: "Sei già iscritto?",
    loginCta: "Accedi",
    signupTitle: "Registrati",
    signupSubtitle: "Crea il tuo account con l'e-mail",
    emailLabel: "E-mail",
    nameLabel: "Nome o nickname",
    passwordLabel: "Password",
    booksellerQuestion: "Sei un libraio?",
    yesLabel: "Sì",
    noLabel: "No",
    storeNamePlaceholder: "Nome della libreria",
    addressPlaceholder: "Indirizzo",
    signupAgreementPrefix: "Registrandoti accetti i nostri",
    signupAgreementAnd: "e",
    termsLinkText: "Termini d'uso",
    privacyLinkText: "Informativa sulla privacy",
    cookiesLinkText: "Cookie Policy",
    signupButtonText: "Registrati",
    alreadyHaveAccount: "Hai già un account?",
    loginLinkText: "Accedi",
    keepSignedIn: "Resta connesso",
    forgotPassword: "Password dimenticata?",
    forgotPasswordTitle: "Password dimenticata?",
    forgotPasswordSubtitle:
      "Inserisci l'e-mail associata al tuo account. Ti invieremo un link sicuro per reimpostare la password.",
    resetPasswordButton: "Reimposta password",
    passwordGuidelines:
      "Crea una password di almeno 10 caratteri, evita parole comuni e non riutilizzare password.",
    newPasswordLabel: "Nuova password",
    confirmNewPasswordLabel: "Conferma nuova password",
    submitButton: "Invia",
    tooltipPassword:
      "Almeno 8 caratteri con lettere maiuscole, minuscole, numeri e caratteri speciali (es. !, @, #, $, %, ^, &).",
    invalidEmail: "Inserisci un indirizzo e-mail valido",
    agreeTermsError:
      "Accetta i termini e le condizioni prima di registrarti.",
    enterEmailError: "Inserisci la tua e-mail",
    passwordLengthError: "La password deve contenere almeno 8 caratteri.",
    passwordUppercaseError:
      "La password deve includere almeno una lettera maiuscola (A–Z).",
    passwordLowercaseError:
      "La password deve includere almeno una lettera minuscola (a–z).",
    passwordNumberError:
      "La password deve includere almeno un numero (0–9).",
    passwordSpecialError:
      "La password deve includere almeno un carattere speciale (!@#$%^&*).",
    passwordMismatchError: "Le password non coincidono.",
    passwordMinLengthReset: "La password deve avere almeno 8 caratteri.",
    resetPasswordTitle: "Reimposta la tua password",
    forgotPasswordHelper:
      "Inserisci l'e-mail associata al tuo account. Ti invieremo un link sicuro per reimpostare la password.",
  },
  deutsch: {
    cookieMessage:
      "Wir verwenden Cookies, um die Website zu betreiben, den Traffic zu analysieren und Inhalte sowie Werbung zu personalisieren.",
    acceptCookies: "Alle akzeptieren",
    rejectCookies: "Ablehnen",
    noNotifications: "Noch keine neuen Benachrichtigungen.",
    createAccountTitle: "Konto erstellen",
    continueGoogle: "Mit Google fortfahren",
    continueFacebook: "Mit Facebook fortfahren",
    continueApple: "Mit Apple fortfahren",
    continueEmail: "Mit E-Mail fortfahren",
    orText: "oder",
    alreadyMemberQuestion: "Bereits Mitglied?",
    loginCta: "Anmelden",
    signupTitle: "Registrieren",
    signupSubtitle: "Erstelle dein Konto mit E-Mail",
    emailLabel: "E-Mail",
    nameLabel: "Name oder Spitzname",
    passwordLabel: "Passwort",
    booksellerQuestion: "Bist du Buchhändler?",
    yesLabel: "Ja",
    noLabel: "Nein",
    storeNamePlaceholder: "Name des Geschäfts",
    addressPlaceholder: "Adresse",
    signupAgreementPrefix:
      "Mit deiner Registrierung akzeptierst du unsere",
    signupAgreementAnd: "und",
    termsLinkText: "Nutzungsbedingungen",
    privacyLinkText: "Datenschutzrichtlinie",
    cookiesLinkText: "Cookie-Richtlinie",
    signupButtonText: "Registrieren",
    alreadyHaveAccount: "Du hast bereits ein Konto?",
    loginLinkText: "Anmelden",
    keepSignedIn: "Angemeldet bleiben",
    forgotPassword: "Passwort vergessen?",
    forgotPasswordTitle: "Passwort vergessen?",
    forgotPasswordSubtitle:
      "Gib die E-Mail-Adresse deines Kontos ein. Wir senden dir einen sicheren Link zum Zurücksetzen.",
    resetPasswordButton: "Passwort zurücksetzen",
    passwordGuidelines:
      "Erstelle ein Passwort mit mindestens 10 Zeichen, vermeide gebräuchliche Wörter und verwende keine alten Passwörter erneut.",
    newPasswordLabel: "Neues Passwort",
    confirmNewPasswordLabel: "Neues Passwort bestätigen",
    submitButton: "Senden",
    tooltipPassword:
      "Mindestens 8 Zeichen mit Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen (z. B. !, @, #, $, %, ^, &).",
    invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein",
    agreeTermsError:
      "Bitte akzeptiere die Geschäftsbedingungen, bevor du dich registrierst.",
    enterEmailError: "Bitte gib deine E-Mail ein",
    passwordLengthError: "Das Passwort muss mindestens 8 Zeichen haben.",
    passwordUppercaseError:
      "Das Passwort muss mindestens einen Großbuchstaben (A–Z) enthalten.",
    passwordLowercaseError:
      "Das Passwort muss mindestens einen Kleinbuchstaben (a–z) enthalten.",
    passwordNumberError:
      "Das Passwort muss mindestens eine Zahl (0–9) enthalten.",
    passwordSpecialError:
      "Das Passwort muss mindestens ein Sonderzeichen (!@#$%^&*) enthalten.",
    passwordMismatchError: "Die Passwörter stimmen nicht überein.",
    passwordMinLengthReset:
      "Das Passwort muss mindestens 8 Zeichen lang sein.",
    resetPasswordTitle: "Setze dein Passwort zurück",
    forgotPasswordHelper:
      "Gib die E-Mail-Adresse deines Kontos ein. Wir senden dir einen sicheren Link zum Zurücksetzen.",
  },
  español: {
    cookieMessage:
      "Usamos cookies para hacer funcionar el sitio, analizar el tráfico y personalizar el contenido y los anuncios.",
    acceptCookies: "Aceptar todo",
    rejectCookies: "Rechazar",
    noNotifications: "Aún no hay notificaciones nuevas.",
    createAccountTitle: "Crea una cuenta",
    continueGoogle: "Continuar con Google",
    continueFacebook: "Continuar con Facebook",
    continueApple: "Continuar con Apple",
    continueEmail: "Continuar con e-mail",
    orText: "o",
    alreadyMemberQuestion: "¿Ya eres miembro?",
    loginCta: "Iniciar sesión",
    signupTitle: "Regístrate",
    signupSubtitle: "Crea tu cuenta con el correo electrónico",
    emailLabel: "Correo electrónico",
    nameLabel: "Nombre o alias",
    passwordLabel: "Contraseña",
    booksellerQuestion: "¿Eres librero?",
    yesLabel: "Sí",
    noLabel: "No",
    storeNamePlaceholder: "Nombre de la librería",
    addressPlaceholder: "Dirección",
    signupAgreementPrefix: "Al registrarte aceptas nuestros",
    signupAgreementAnd: "y",
    termsLinkText: "Términos de uso",
    privacyLinkText: "Política de privacidad",
    cookiesLinkText: "Política de cookies",
    signupButtonText: "Regístrate",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    loginLinkText: "Inicia sesión",
    keepSignedIn: "Mantener sesión iniciada",
    forgotPassword: "¿Olvidaste la contraseña?",
    forgotPasswordTitle: "¿Olvidaste la contraseña?",
    forgotPasswordSubtitle:
      "Introduce el correo asociado a tu cuenta. Te enviaremos un enlace seguro para restablecer la contraseña.",
    resetPasswordButton: "Restablecer contraseña",
    passwordGuidelines:
      "Crea una contraseña de al menos 10 caracteres, evita palabras comunes y no reutilices contraseñas.",
    newPasswordLabel: "Nueva contraseña",
    confirmNewPasswordLabel: "Confirmar nueva contraseña",
    submitButton: "Enviar",
    tooltipPassword:
      "Al menos 8 caracteres con mayúsculas, minúsculas, números y caracteres especiales (p. ej., !, @, #, $, %, ^, &).",
    invalidEmail: "Introduce un correo electrónico válido",
    agreeTermsError:
      "Acepta los términos y condiciones antes de registrarte.",
    enterEmailError: "Introduce tu correo electrónico",
    passwordLengthError:
      "La contraseña debe tener al menos 8 caracteres.",
    passwordUppercaseError:
      "La contraseña debe incluir al menos una letra mayúscula (A–Z).",
    passwordLowercaseError:
      "La contraseña debe incluir al menos una letra minúscula (a–z).",
    passwordNumberError:
      "La contraseña debe incluir al menos un número (0–9).",
    passwordSpecialError:
      "La contraseña debe incluir al menos un carácter especial (!@#$%^&*).",
    passwordMismatchError: "Las contraseñas no coinciden.",
    passwordMinLengthReset:
      "La contraseña debe tener al menos 8 caracteres.",
    resetPasswordTitle: "Restablece tu contraseña",
    forgotPasswordHelper:
      "Introduce el correo asociado a tu cuenta. Te enviaremos un enlace seguro para restablecer la contraseña.",
  },
  francais: {
    cookieMessage:
      "Nous utilisons des cookies pour faire fonctionner le site, analyser le trafic et personnaliser le contenu ainsi que les publicités.",
    acceptCookies: "Tout accepter",
    rejectCookies: "Refuser",
    noNotifications: "Pas encore de nouvelles notifications.",
    createAccountTitle: "Créer un compte",
    continueGoogle: "Continuer avec Google",
    continueFacebook: "Continuer avec Facebook",
    continueApple: "Continuer avec Apple",
    continueEmail: "Continuer avec e-mail",
    orText: "ou",
    alreadyMemberQuestion: "Déjà membre ?",
    loginCta: "Se connecter",
    signupTitle: "S'inscrire",
    signupSubtitle: "Créez votre compte avec votre e-mail",
    emailLabel: "E-mail",
    nameLabel: "Nom ou pseudo",
    passwordLabel: "Mot de passe",
    booksellerQuestion: "Êtes-vous libraire ?",
    yesLabel: "Oui",
    noLabel: "Non",
    storeNamePlaceholder: "Nom de la librairie",
    addressPlaceholder: "Adresse",
    signupAgreementPrefix:
      "En vous inscrivant, vous acceptez nos",
    signupAgreementAnd: "et",
    termsLinkText: "Conditions d'utilisation",
    privacyLinkText: "Politique de confidentialité",
    cookiesLinkText: "Politique relative aux cookies",
    signupButtonText: "S'inscrire",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    loginLinkText: "Se connecter",
    keepSignedIn: "Rester connecté",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordTitle: "Mot de passe oublié ?",
    forgotPasswordSubtitle:
      "Saisissez l'e-mail associé à votre compte. Nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe.",
    resetPasswordButton: "Réinitialiser le mot de passe",
    passwordGuidelines:
      "Créez un mot de passe d'au moins 10 caractères, évitez les mots courants et ne réutilisez pas vos anciens mots de passe.",
    newPasswordLabel: "Nouveau mot de passe",
    confirmNewPasswordLabel: "Confirmer le nouveau mot de passe",
    submitButton: "Envoyer",
    tooltipPassword:
      "Au moins 8 caractères avec des lettres majuscules, minuscules, des chiffres et des caractères spéciaux (ex. !, @, #, $, %, ^, &).",
    invalidEmail: "Veuillez saisir une adresse e-mail valide",
    agreeTermsError:
      "Veuillez accepter les termes et conditions avant de vous inscrire.",
    enterEmailError: "Veuillez saisir votre e-mail",
    passwordLengthError:
      "Le mot de passe doit comporter au moins 8 caractères.",
    passwordUppercaseError:
      "Le mot de passe doit contenir au moins une lettre majuscule (A–Z).",
    passwordLowercaseError:
      "Le mot de passe doit contenir au moins une lettre minuscule (a–z).",
    passwordNumberError:
      "Le mot de passe doit contenir au moins un chiffre (0–9).",
    passwordSpecialError:
      "Le mot de passe doit contenir au moins un caractère spécial (!@#$%^&*).",
    passwordMismatchError: "Les mots de passe ne correspondent pas.",
    passwordMinLengthReset:
      "Le mot de passe doit contenir au moins 8 caractères.",
    resetPasswordTitle: "Réinitialisez votre mot de passe",
    forgotPasswordHelper:
      "Saisissez l'e-mail associé à votre compte. Nous vous enverrons un lien sécurisé pour réinitialiser votre mot de passe.",
  },
  nihongo: {
    cookieMessage:
      "当サイトでは、サイトの運営、トラフィック分析、コンテンツや広告のパーソナライズのためにクッキーを使用しています。",
    acceptCookies: "すべて許可",
    rejectCookies: "拒否する",
    noNotifications: "新しい通知はまだありません。",
    createAccountTitle: "アカウントを作成",
    continueGoogle: "Googleで続行",
    continueFacebook: "Facebookで続行",
    continueApple: "Appleで続行",
    continueEmail: "メールで続行",
    orText: "または",
    alreadyMemberQuestion: "すでに会員ですか？",
    loginCta: "ログイン",
    signupTitle: "登録する",
    signupSubtitle: "メールでアカウントを作成",
    emailLabel: "メールアドレス",
    nameLabel: "名前またはニックネーム",
    passwordLabel: "パスワード",
    booksellerQuestion: "書店スタッフですか？",
    yesLabel: "はい",
    noLabel: "いいえ",
    storeNamePlaceholder: "店舗名",
    addressPlaceholder: "住所",
    signupAgreementPrefix: "登録すると、次の内容に同意したことになります",
    signupAgreementAnd: "および",
    termsLinkText: "利用規約",
    privacyLinkText: "プライバシーポリシー",
    cookiesLinkText: "クッキーポリシー",
    signupButtonText: "登録する",
    alreadyHaveAccount: "すでにアカウントをお持ちですか？",
    loginLinkText: "ログイン",
    keepSignedIn: "ログイン状態を維持",
    forgotPassword: "パスワードをお忘れですか？",
    forgotPasswordTitle: "パスワードをお忘れですか？",
    forgotPasswordSubtitle:
      "アカウントに登録したメールアドレスを入力してください。パスワード再設定用の安全なリンクをお送りします。",
    resetPasswordButton: "パスワードをリセット",
    passwordGuidelines:
      "パスワードは10文字以上で、一般的な単語を避け、過去のパスワードは使用しないでください。",
    newPasswordLabel: "新しいパスワード",
    confirmNewPasswordLabel: "新しいパスワードの確認",
    submitButton: "送信",
    tooltipPassword:
      "8文字以上で、大文字・小文字・数字・記号（!, @, #, $, %, ^, & など）を含めてください。",
    invalidEmail: "有効なメールアドレスを入力してください",
    agreeTermsError: "登録する前に利用規約に同意してください。",
    enterEmailError: "メールアドレスを入力してください",
    passwordLengthError: "パスワードは8文字以上である必要があります。",
    passwordUppercaseError:
      "パスワードには少なくとも1文字の大文字（A–Z）が必要です。",
    passwordLowercaseError:
      "パスワードには少なくとも1文字の小文字（a–z）が必要です。",
    passwordNumberError:
      "パスワードには少なくとも1つの数字（0–9）が必要です。",
    passwordSpecialError:
      "パスワードには少なくとも1つの記号 (!@#$%^&*) が必要です。",
    passwordMismatchError: "パスワードが一致しません。",
    passwordMinLengthReset:
      "パスワードは少なくとも8文字で入力してください。",
    resetPasswordTitle: "パスワードをリセット",
    forgotPasswordHelper:
      "アカウントに登録したメールアドレスを入力してください。パスワード再設定用の安全なリンクをお送りします。",
  },
  nederlands: {
    cookieMessage:
      "We gebruiken cookies om de site te bedienen, verkeer te analyseren en inhoud en advertenties te personaliseren.",
    acceptCookies: "Alles accepteren",
    rejectCookies: "Afwijzen",
    noNotifications: "Nog geen nieuwe meldingen.",
    createAccountTitle: "Maak een account",
    continueGoogle: "Doorgaan met Google",
    continueFacebook: "Doorgaan met Facebook",
    continueApple: "Doorgaan met Apple",
    continueEmail: "Doorgaan met E-mail",
    orText: "of",
    alreadyMemberQuestion: "Al lid?",
    loginCta: "Inloggen",
    signupTitle: "Aanmelden",
    signupSubtitle: "Maak je account met e-mail",
    emailLabel: "E-mail",
    nameLabel: "Naam of bijnaam",
    passwordLabel: "Wachtwoord",
    booksellerQuestion: "Ben je een boekhandelaar?",
    yesLabel: "Ja",
    noLabel: "Nee",
    storeNamePlaceholder: "Naam van de winkel",
    addressPlaceholder: "Adres",
    signupAgreementPrefix: "Door je aan te melden, ga je akkoord met onze",
    signupAgreementAnd: "en",
    termsLinkText: "Gebruiksvoorwaarden",
    privacyLinkText: "Privacybeleid",
    cookiesLinkText: "Cookiebeleid",
    signupButtonText: "Aanmelden",
    alreadyHaveAccount: "Heb je al een account?",
    loginLinkText: "Inloggen",
    keepSignedIn: "Houd me ingelogd",
    forgotPassword: "Wachtwoord vergeten?",
    forgotPasswordTitle: "Wachtwoord vergeten?",
    forgotPasswordSubtitle:
      "Voer het e-mailadres in dat aan je account is gekoppeld. We sturen je een veilige link om je wachtwoord te resetten.",
    resetPasswordButton: "Wachtwoord resetten",
    passwordGuidelines:
      "Maak een wachtwoord met minimaal 10 tekens, vermijd veelvoorkomende woorden en hergebruik geen wachtwoorden.",
    newPasswordLabel: "Nieuw wachtwoord",
    confirmNewPasswordLabel: "Bevestig nieuw wachtwoord",
    submitButton: "Verzenden",
    tooltipPassword:
      "Minimaal 8 tekens, hoofdletters (A–Z), kleine letters (a–z), cijfers (0–9) en speciale tekens (bijv. !, @, #, $, %, ^, &).",
    invalidEmail: "Voer een geldig e-mailadres in",
    agreeTermsError:
      "Ga akkoord met de voorwaarden voordat je je aanmeldt.",
    enterEmailError: "Voer je e-mail in",
    passwordLengthError: "Wachtwoord moet minimaal 8 tekens bevatten.",
    passwordUppercaseError:
      "Wachtwoord moet minimaal één hoofdletter (A–Z) bevatten.",
    passwordLowercaseError:
      "Wachtwoord moet minimaal één kleine letter (a–z) bevatten.",
    passwordNumberError:
      "Wachtwoord moet minimaal één cijfer (0–9) bevatten.",
    passwordSpecialError:
      "Wachtwoord moet minimaal één speciaal teken (!@#$%^&*) bevatten.",
    passwordMismatchError: "Wachtwoorden komen niet overeen.",
    passwordMinLengthReset: "Wachtwoord moet minimaal 8 tekens lang zijn.",
    resetPasswordTitle: "Reset je wachtwoord",
    forgotPasswordHelper:
      "Voer het e-mailadres in dat aan je account is gekoppeld. We sturen je een veilige link om je wachtwoord te resetten.",
  },
  chinese: {
    cookieMessage:
      "我们使用Cookie来运营网站、分析流量并个性化内容和广告。",
    acceptCookies: "全部接受",
    rejectCookies: "拒绝",
    noNotifications: "还没有新通知。",
    createAccountTitle: "创建账户",
    continueGoogle: "使用Google继续",
    continueFacebook: "使用Facebook继续",
    continueApple: "使用Apple继续",
    continueEmail: "使用电子邮件继续",
    orText: "或",
    alreadyMemberQuestion: "已经是会员？",
    loginCta: "登录",
    signupTitle: "注册",
    signupSubtitle: "使用电子邮件创建您的账户",
    emailLabel: "电子邮件",
    nameLabel: "姓名或昵称",
    passwordLabel: "密码",
    booksellerQuestion: "您是书商吗？",
    yesLabel: "是",
    noLabel: "否",
    storeNamePlaceholder: "商店名称",
    addressPlaceholder: "地址",
    signupAgreementPrefix: "注册即表示您同意我们的",
    signupAgreementAnd: "和",
    termsLinkText: "使用条款",
    privacyLinkText: "隐私政策",
    cookiesLinkText: "Cookie政策",
    signupButtonText: "注册",
    alreadyHaveAccount: "已有账户？",
    loginLinkText: "登录",
    keepSignedIn: "保持登录状态",
    forgotPassword: "忘记密码？",
    forgotPasswordTitle: "忘记密码？",
    forgotPasswordSubtitle:
      "输入与您账户关联的电子邮件。我们将向您发送一个安全链接以重置密码。",
    resetPasswordButton: "重置密码",
    passwordGuidelines:
      "请创建一个至少10个字符的密码，避免使用常见词汇，不要重复使用密码。",
    newPasswordLabel: "新密码",
    confirmNewPasswordLabel: "确认新密码",
    submitButton: "提交",
    tooltipPassword:
      "至少8个字符，包括大写字母（A–Z）、小写字母（a–z）、数字（0–9）和特殊字符（例如！、@、#、$、%、^、&）。",
    invalidEmail: "请输入有效的电子邮件地址",
    agreeTermsError: "注册前请同意条款和条件。",
    enterEmailError: "请输入您的电子邮件",
    passwordLengthError: "密码必须至少包含8个字符。",
    passwordUppercaseError: "密码必须包含至少一个大写字母（A–Z）。",
    passwordLowercaseError: "密码必须包含至少一个小写字母（a–z）。",
    passwordNumberError: "密码必须包含至少一个数字（0–9）。",
    passwordSpecialError: "密码必须包含至少一个特殊字符（!@#$%^&*）。",
    passwordMismatchError: "密码不匹配。",
    passwordMinLengthReset: "密码必须至少8个字符长。",
    resetPasswordTitle: "重置您的密码",
    forgotPasswordHelper:
      "输入与您账户关联的电子邮件。我们将向您发送一个安全链接以重置密码。",
  },
};

// Lanuguage Change All

const Header3 = () => {
  const [isBookseller, setIsBookseller] = useState(""); // yes / no / ""
  const { lg, selectedLanguage, setSelectedLanguage } = useContext(LanguageContext);
  const headerText = headerCopy[selectedLanguage] ?? headerCopy.english;
  // const { notifications } = useContext(NotificationContext);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibilityy = () => setShowPassword((prev) => !prev);
  const { notifications, setNotifications } = useContext(NotificationContext);
  const { setUser, showLoginM, setShowLoginM } = ChatState();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    if (showLoginM) {
      console.log(showLoginM, "showLoginM");

      setShow(showLoginM);
      //setShow(showLoginM);
    }
  }, [showLoginM]);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [show, setShow] = useState(false); // For signup modal
  const [showLogin, setShowLogin] = useState(false); // For login modal
  const [showEmail, setShowEmail] = useState(false); // For login modal

  // Handle closing both modals
  const handleClose = () => {
    setShow(false); // Close signup modal
    setShowLogin(false); // Close login modal
    setShowEmail(false);
    setShowLoginM(false);
    localStorage.setItem("modalClosedH", "true");
  };

  // Handle opening signup modal
  const handleShow = () => {
    setShow(true); // Open signup modal
    setShowLogin(false); // Close login modal if open
    setShowEmail(false);
  };

  // Handle opening signup modal
  const handleShowEmail = () => {
    setShowEmail(true); // Open signup modal
    setShow(false);
    setShowLoginM(false);
    setShowLogin(false); // Close login modal if open
  };

  const handleEmailClose = () => {
    setShow(false); // Close signup modal
    setShowLogin(false); // Close login modal
    setShowEmail(false);
    setShowLoginM(false);
  };
  const [emailError, setEmailError] = useState("");

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
      setEmailError(headerText.invalidEmail);
    } else {
      setEmailError("");
    }
  };
  // Handle opening login modal
  const handleLoginShow = () => {
    setShow(false); // Close signup modal
    setShowEmail(false);
    setShowLogin(true); // Open login modal7
    setShowLoginM(false);
  };

  // Handle closing login modal
  const handleLoginClose = () => {
    setShowLogin(false); // Close login modal
    setShowLoginM(false);
  };

  const location = useLocation();
  const navigate = useNavigate();

  const [fShow, setFShow] = useState(false); // For Forget Password modal
  const [localNotifications, setLocalNotifications] = useState([]);
  useEffect(() => {
    console.log("changing in chat");
    setLocalNotifications([]); // Clear existing notifications
    setTimeout(() => {
         setLocalNotifications([...notifications]); // spread ensures new ref
    }, 100);


  }, [notifications]);
  const handleFClose = () => {
    setFShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleFShow = () => {
    setFShow(true); // Open Forget Password  modal
    setShowLogin(false);
    setShowLoginM(false);
  };

  const [fPShow, setFPShow] = useState(false); // For Forget Password modal
  const [showForgot, setShowForgot] = useState(false);
  const handleFPClose = () => {
    setFPShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleFPShow = () => {
    setFPShow(true); // Open Forget Password  modal
    setShowLogin(false);
    setShowLoginM(false);
    setFShow(false);
  };

  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      return toast.error(headerText.enterEmailError);
    }

    try {
      setLoading(true);
      const res = await axios.post("api/v1/auth/forgot-password", { email });
      toast.success(res.data.message);
      setShowForgot(false);
      handleFPClose(true);
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const [passwordNewVisible, setPasswordNewVisible] = useState(false);

  const togglePasswordNewVisibility = () => {
    setPasswordNewVisible((prevState) => !prevState);
  };
  const [lShow, setLShow] = useState(false); // For signup modal
  const handleLClose = () => {
    setLShow(false); // Close signup modal
  };

  const handleLShow = () => {
    setLShow(true); // Open signup modal
  };

  const handleLanguageChange = (val) => {
    const lang = val.target.value;
    setSelectedLanguage(lang);
    // localStorage.setItem("language", lang);
    // console.log("Language changed to:", lang);
    //handleLClose(true); // close modal after selection
  };

  // ============== Integration =====================

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [seller, setSeller] = useState("");
  const [storeName, setStoreName] = useState("");
  const [storeAddress, setStoreAddress] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [auth, setAuth] = useAuth();
  const isAdmin = auth?.user?.isAdmin || false; // Ensure isAdmin is always a boolean
  const [profileImage, setProfileImage] = useState(
    localStorage.getItem("profileImage") || ""
  );
  // SignUP function
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      toast.error(headerText.agreeTermsError);
      return;
    }

    const passwordErrors = [];

    if (password.length < 8) {
      passwordErrors.push(headerText.passwordLengthError);
    }
    if (!/[A-Z]/.test(password)) {
      passwordErrors.push(headerText.passwordUppercaseError);
    }
    if (!/[a-z]/.test(password)) {
      passwordErrors.push(headerText.passwordLowercaseError);
    }
    if (!/[0-9]/.test(password)) {
      passwordErrors.push(headerText.passwordNumberError);
    }
    if (!/[!@#$%^&*]/.test(password)) {
      passwordErrors.push(headerText.passwordSpecialError);
    }

    // 🔸 Show each missing requirement in a separate toast
    if (passwordErrors.length > 0) {
      passwordErrors.forEach((err) => toast.error(err));
      return;
    }

    try {
      const res = await axios.post("/api/v1/auth/register", {
        name,
        email,
        password,
        seller: bookseller == true ? "Yes" : "No", // <--- Use this
        storeName,
        storeAddress,
        language: selectedLanguage,
      });
      if (res && res.data.success) {
        toast.success(res.data && res.data.message);
        setAuth({
          user: res.data.user,
          token: res.data.token,
        });
        setUser(res.data.user);
        // ✅ LocalStorage me save karein
        localStorage.setItem(
          "auth",
          JSON.stringify({
            user: res.data.user,
            token: res.data.token,
          })
        );
        // ✅ Google Analytics Signup Event
        trackEvent("user_signup", {
            method: "Email", // Or "Google", "Facebook", etc.
            email: email,
            // city: city,
            // country: country,
          });
          console.log("✅ Google Analytics signup event sent:", {
            method: "Email",
            email,
            // city,
            // country,
          });

        setEmail("");
        setName("");
        setPassword("");
        // setCity("");
        // setCountry("");
        // setGender("");
        // setDateOfBirth("");
        setSeller("");
        setStoreName("");
        setIsBookseller("");
        setStoreAddress("");
        setIsChecked("");
        setShowEmail(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };
  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/api/v1/auth/login", { email, password });

      if (res && res.data.success) {
        toast.success(res.data.message);
        setEmail("");
        setPassword("");

        // ✅ Token aur user info update karein
        setAuth({
          user: res.data.user,
          token: res.data.token,
        });
        setUser(res.data.user);
        // ✅ LocalStorage me save karein
        localStorage.setItem(
          "auth",
          JSON.stringify({
            user: res.data.user,
            token: res.data.token,
          })
        );

        setShowLogin(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  // FAtch User Details
  const userId = auth?.user?._id;
  const [users, setUsers] = useState(null);
  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`/api/v1/auth/user-profile/${userId}`);
        setUsers(res.data.data);
        localStorage.setItem("profileImage", res.data.data.profileImage);
        setProfileImage(res.data.data.profileImage);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);
  // ===============Logout=================
  const handleLogout = () => {
    setAuth({
      ...auth,
      user: null,
      token: "",
    });
    localStorage.removeItem("auth");
    localStorage.removeItem("profileImage");

    toast.success("Logout Successfully");
    setUser(null);
    // Navigate to homepage
    navigate("/");
    // window.location.reload(); // Reload the page to reflect changes
  };
  // OTHer
  const clientId =
    "500630261375-7capo8anko4108t790kb7o8juijd2a8j.apps.googleusercontent.com"; // Replace with your actual client ID

  const handleLoginSuccess = async (response) => {
    const idToken = response.credential;

    try {
      // Send the ID token to your backend
      const backendResponse = await axios.post("api/google-login", {
        token: idToken,
        language: selectedLanguage,
      });

      setAuth({
        ...auth,
        user: backendResponse.data.user,
        token: backendResponse.data.token,
      });
      localStorage.setItem("auth", JSON.stringify(backendResponse.data));
      setShowLogin(false);
      setShow(false);
      setShowLoginM(false);

      toast.success("Login Successfully");
    } catch (error) {
      console.error("Error sending token to backend:", error);
      toast.error(error.response?.data?.message || "Something went wrong.");
    }
  };

  const handleFacebookLogin = () => {
    // Load the Facebook SDK if it's not loaded yet
    if (!window.FB) {
      loadFacebookSDK();
    } else {
      // Log in with Facebook
      window.FB.login(
        function (response) {
          if (response.authResponse) {
            console.log("Facebook login successful!", response);
            const { accessToken } = response.authResponse;

            axios
              .post(
                `${process.env.REACT_APP_API}/api/facebook-login`,
                { accessToken, language: selectedLanguage },
                { withCredentials: true }
              )
              .then((backendResponse) => {
                // Assuming the backend responds with user data and a token
                const { user, token } = backendResponse.data;

                // Set data in your auth context/state (if using Redux or Context)
                setAuth({
                  ...auth,
                  user: user,
                  token: token,
                });

                // Store the data in localStorage for persistence across page reloads
                localStorage.setItem(
                  "auth",
                  JSON.stringify(backendResponse.data)
                );
                toast.success("Login Successfully");

                // Optionally, hide the login modal or perform other UI updates
                setShowLogin(false);
                setShowLoginM(false);
                setShow(false);

                console.log("Backend response:", backendResponse.data);
              })
              .catch((err) => {
                toast.error(
                  err.response?.data?.message || "Something went wrong."
                );

                console.error("Error sending token to backend:", err);
              });
          } else {
            console.error("User cancelled login or did not fully authorize.");
          }
        },
        { scope: "email,public_profile" }
      );
    }
  };
  const handleFacebookResponse = async (response) => {
    try {
      if (!response.accessToken) {
        console.error("Facebook login failed");
        return;
      }

      // Send user info to backend
      const res = await axios.post(`/facebook-login`, {
        userInfo: {
          id: response.id,
          name: response.name,
          email: response.email,
          picture: response.picture?.data?.url,
          provider: "facebook",
        },
        language: selectedLanguage,
      });

      setAuth({
        ...auth,
        user: res.data.user,
        token: res.data.token,
      });
      toast.success("Login Successfully");
setUser(res.data.user)
      // Optionally, hide the login modal or perform other UI updates
      setShowLogin(false);
      setShowLoginM(false);
      setShow(false);
      console.log("Facebook login success:", res.data);
    } catch (error) {
      console.error("Facebook login error:", error);
    }
  };
  // Function to dynamically load the Facebook SDK
  const loadFacebookSDK = () => {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  };
  // ================== PAssowrd Forget ========================
  const { token } = useParams(); // 🏷 Get token from URL
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  // ✅ Auto open modal if token exists
  useEffect(() => {
    if (token) {
      handleFShow(true); // Show modal
    }
  }, [token]);
  // 📩 Submit Password Reset Request
  const handleSubmitForget = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      return toast.error(headerText.passwordMinLengthReset);
    }
    if (newPassword !== confirmNewPassword) {
      return toast.error(headerText.passwordMismatchError);
    }

    try {
      const res = await axios.post(`/api/v1/resetpassword/reset/${token}`, {
        newPassword,
        confirmNewPassword,
      });

      if (res.data.success) {
        toast.success(res.data.message);
        handleFClose(true); // Close modal
        handleLoginShow(true); // Redirect to login page
        navigate("/");
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };
  // Check location state to open modal if triggered
  useEffect(() => {
    const isModalClosedH = localStorage.getItem("modalClosedH");

    if (location.state?.show && !isModalClosedH) {
      setShow(true);
    }
  }, [location.state]);
  const [bookseller, setBookseller] = useState(null);
  const GoogleLogo = () => (
    <svg viewBox="0 0 48 48" width="20" height="20" aria-hidden>
      <path
        fill="#FFC107"
        d="M43.611 20.083H42V20H24v8h11.303c-1.648 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.342-.138-2.651-.389-3.917z"
      />
      <path
        fill="#FF3D00"
        d="M6.306 14.691l6.571 4.819C14.266 16.265 18.74 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.155 0 9.86-1.977 13.409-5.202l-6.191-5.236C29.18 35.091 26.716 36 24 36c-5.203 0-9.619-3.317-11.278-7.946l-6.536 5.033C9.5 39.556 16.227 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.095 5.562l6.191 5.236C39.144 36.644 44 31.5 44 24c0-1.342-.138-2.651-.389-3.917z"
      />
    </svg>
  );

  const FacebookLogo = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <path
        fill="#1877F2"
        d="M24 12.073C24 5.406 18.627 0 12 0S0 5.406 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.007 1.792-4.667 4.533-4.667 1.313 0 2.686.238 2.686.238v2.953h-1.513c-1.491 0-1.955.929-1.955 1.883v2.259h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"
      />
    </svg>
  );

  const AppleLogo = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <path
        fill="#000"
        d="M16.365 1.43c0 1.14-.47 2.27-1.23 3.1-.77.83-2.03 1.47-3.21 1.38-.14-1.11.45-2.3 1.17-3.06.84-.92 2.28-1.58 3.27-1.42.02.03.02.06.02.1zm3.2 16.16c-.6 1.38-1.33 2.75-2.4 3.9-1 .98-2.21 2.1-3.78 2.12-1.49.02-1.98-.95-3.69-.95-1.72 0-2.25.93-3.72.97-1.58.03-2.79-1.06-3.8-2.04C.94 19.6-.64 15.7.53 12.66c.56-1.49 1.56-2.8 2.79-3.68 1.34-.96 3.06-1.26 4.64-.75.62.2 1.15.54 1.66.8.43.22.99.52 1.62.5.54-.02 1.08-.31 1.51-.54.65-.35 1.3-.71 2.03-.9 1.78-.46 3.59.11 4.83 1.2-.19.27-1.7 1.12-1.88 3.26-.02.26-.03.53-.03.8 0 2.31 1.37 3.07 1.64 3.22-.2.55-.44 1.09-.76 1.47z"
      />
    </svg>
  );

  const SocialButton = ({ icon, label, onClick, variant = "neutral" }) => (
    <button
      onClick={onClick}
      className={`w-full inline-flex items-center gap-3 justify-center rounded-xl px-4 py-2.5 text-[15px] ring-1 transition ${variant === "primary"
          ? "bg-[var(--primary)] text-white ring-[var(--primary)] hover:brightness-95"
          : "bg-white text-slate-800 ring-[#e6e6e6] hover:bg-slate-50"
        }`}
      style={{ ["--primary"]: PRIMARY }}
    >
      <span className="inline-flex h-5 w-5 items-center justify-center">
        {icon}
      </span>
      <span className="flex-1 text-center">{label}</span>
    </button>
  );
  const [showBanner, setShowBanner] = useState(false);
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const accessToken = tokenResponse.access_token;
      const token = tokenResponse.credential;
      console.log(tokenResponse);
      // Option 1: get user info from Google
      const userInfo = await axios.get(
        "https://www.googleapis.com/oauth2/v3/userinfo",
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const res = await axios.post(`/google-login`, {
        userInfo: userInfo.data,
        language: selectedLanguage,
      });
      setUser(res.data.user);
      localStorage.setItem(
        "auth",
        JSON.stringify({
          user: res.data.user,
          token: res.data.token,
        })
      );
      setAuth({
        ...auth,
        user: res.data.user,
        token: res.data.token,
      });
      toast.success("Logged in");
      navigate("/");
      setShowLoginM(false);
      setShow(false);
      console.log("Google User Info:", userInfo.data);

      // Option 2: send to your backend
      // await axios.post(`${BASE_URL}/api/auth/google`, { accessToken });
    },
    onError: () => {
      console.error("Google Login Failed");
    },
  });
  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);
  const handleUpdateProfile = async (choice) => {
    try {
      const response = await axios.put(
        `api/v1/auth/update-profile/${auth.user?._id}`,
        { cookies: choice == "accepted" ? true : false },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        setUser(response.data.data); // Update frontend state
        window.location.reload(); // Reload the page to reflect changes
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      // toast.error("Error updating profile");
    }
  };
  const handleConsent = (choice) => {
    localStorage.setItem("cookieConsent", choice);
    handleUpdateProfile(choice);
    setShowBanner(false);
  };

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        style={{ backgroundColor: "#34C3C9" }}
        className="py-0"
      // className="bg-body-tertiary"
      >
        <Container className="classsheder">
          <Navbar.Brand href="/" className="p-0">
            <img
              className=" w-sm-100 mlogowidth  mt-1 mb-2"
              src={require("../components/image/ofelliologocr.png")}
              alt="logo"
              width="220"
              height="auto"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            style={{
              borderColor: "white", // بارڈر کلر سفید
              color: "white", // لائن کلر سفید (لائن آئیکن کے لیے)
            }}
          />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="z-index-2 w-100 position-relative pb-lg-0 pb-4 text-center position-absolute topclass top-sm-3 "
            style={{
              background: "#34C3C9",
            }}
          >
            <Nav
              style={{ gap: "10px", color: "#FFFFFF" }}
              className="ms-auto  "
            >
              <Nav.Link
                id="works"
                className="ftznav fw-bold"
                href="/#howitworks"
                style={{
                  color: "#FFFFFF",

                  lineHeight: "24.51px",
                  fontSize: "16px",
                }}
              >
                {/* How it works */}
                {headerHow[selectedLanguage]?.howText}
              </Nav.Link>

              {/* Ambassador link removed - all users are now ambassadors */}
              {/* <Nav.Link
                href="/ambassador"
                className="ftznav fw-bold"
                style={{
                  color: "#FFFFFF",

                  lineHeight: "24.51px",
                  fontSize: "16px",
                }}
              >
                {lg?.ambassador || "Ambassador"}
              </Nav.Link> */}

              <Dropdown>
                <Dropdown.Toggle as="div">
                  <Nav.Link
                    // href="/booksandreviews"
                    className="ftznav fw-bold"
                    style={{
                      color: "#FFFFFF",

                      lineHeight: "24.51px",
                      fontSize: "16px",
                    }}
                    onClick={() => navigate("/booksandreviews")}
                  >
                    {/* Books & Reviews */}
                    {headerBR[selectedLanguage]?.BAndRText}
                  </Nav.Link>
                </Dropdown.Toggle>
              </Dropdown>

              {!auth?.user ? (
                <>
                  <Nav.Link
                    className="ftznav fw-bold"
                    href="#"
                    style={{
                      color: "#FFFFFF",

                      lineHeight: "24.51px",
                      fontSize: "16px",
                    }}
                    onClick={handleShow} // Show login modal
                  >
                    {/* Log in/Sign up */}
                    {headerlogin[selectedLanguage]?.loginText}
                  </Nav.Link>
                </>
              ) : (
                <>
                  <div className="mt-1 px-1  " style={{ cursor: "pointer" }}>
                    <img
                      className=" mt-2 mx-auto mx-lg-0 hidden lg:block"
                      src={require("../components/image/msgbox.png")}
                      alt="logo"
                      width="20.53px"
                      onClick={() => navigate("/chatChak")}
                      style={{ width: "21px", height: "21px" }}
                    />
                    <div
                      className="ftznav fw-bold block lg:hidden"
                      style={{
                        color: "#FFFFFF",

                        lineHeight: "24.51px",
                        fontSize: "16px",
                      }}
                      onClick={() => navigate("/chatChak")}
                    >
                      {lg?.msgtext || "Messages"}
                    </div>
                  </div>

                  <div
                    className="position-relative hidden sm:block"
                    ref={dropdownRef}
                  >
                    <div
                      className="  px-1"
                      onClick={() => setOpen(!open)}
                      style={{ cursor: "pointer", marginTop: "12px" }}
                    >
                      <Badge dot={localNotifications.some((n) => !n.read)}>
                        <img
                          src={require("../components/image/notification.png")}
                          alt="Notifications"
                          width="24"
                          style={{ width: "21px", height: "21px" }}
                        />
                      </Badge>
                    </div>
                    {showBanner && (
                      <div className="fixed inset-x-0 bottom-0 z-50 flex justify-center items-center p-2 bg-[#F2F2F2] shadow-md border-t border-gray-300 font-sans">
                        <div className="max-w-sm w-full flex flex-col items-center gap-1 rounded-xl p-2 text-center">
                          <p className="text-xs text-gray-800 whitespace-nowrap overflow-hidden text-ellipsis">
                            {headerText.cookieMessage}
                          </p>
                          <div className="flex flex-row gap-2 justify-center mt-1">
                            <button
                              type="button"
                              onClick={() => handleConsent("accepted")}
                              className="px-4 py-1 rounded-md bg-[#34C3C9] text-white text-xs font-semibold hover:bg-[#2faab0] transition min-w-[90px]"
                              aria-label="Accept all cookies"
                            >
                              {headerText.acceptCookies}
                            </button>
                            <button
                              type="button"
                              onClick={() => handleConsent("rejected")}
                              className="px-4 py-1 rounded-md bg-white text-[#34C3C9] border border-[#34C3C9] text-xs font-semibold hover:bg-[#e8f9fa] transition min-w-[90px]"
                              aria-label="Reject non-essential cookies"
                            >
                              {headerText.rejectCookies}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {open && (
                      <div
                        key={`notif-${localNotifications.length}-${Date.now()}`}
                        className="position-absolute bg-white rounded-1 boxshonotif"
                        style={{
                          top: "40px",
                          right: "0",
                          width: "330px",
                          zIndex: 1000,
                          maxHeight: "350px",
                          overflowY: "auto",
                        }}
                      >
                        {localNotifications.length > 0 ? (
                          localNotifications.map((notification, index) => (
                            <div
                              key={notification?._id || index}
                              className="d-flex align-items-center gap-2 px-3 py-2 border-bottom"
                              style={{ cursor: "pointer" }}
                              onClick={async (e) => {
                                e.stopPropagation();
                                console.log("Notification data:", notification);

                                try {
                                  const response = await axios.put(
                                    `/api/mark-as-read/${notification._id}`
                                  );

                                  if (response.status === 200) {
                                    // ✅ Update state without refreshing the page
                                    setNotifications((prev) =>
                                      prev.map((n) =>
                                        n._id === notification._id
                                          ? { ...n, read: true }
                                          : n
                                      )
                                    );
                                  } else {
                                    console.error(
                                      "Failed to mark notification as read:",
                                      response.data
                                    );
                                  }
                                } catch (error) {
                                  console.error(
                                    "Error updating notification:",
                                    error
                                  );
                                }

                                navigate(notification.onClickPath);
                                setOpen(false);
                              }}
                            >
                              {/* User Image or Default Bell Icon */}
                              {notification.image ? (
                                <img
                                  src={notification.image?.startsWith("http")?notification.image:`${BASE_URL}/uploads/${notification.image}`}
                                  alt="user"
                                  className="rounded-circle"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <img
                                  src={require("../pages/image/addphotoicon.png")}
                                  alt="user"
                                  className="rounded-circle"
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                              <span
                                className="text-wrap text-drak fw600 w-100 position-relative"
                                style={{
                                  opacity: "1",
                                  color: "black",
                                  maxWidth: "235px",
                                  minWidth: "235px",
                                  textAlign: "left",
                                }}
                              >
                                {translateNotification(notification.message, lg)}
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "47px",
                                    lineHeight: "0px",
                                    position: "absolute",
                                    top: "-5px",
                                    right: "-10px",
                                  }}
                                >
                                  {!notification?.read && "."}
                                </span>
                              </span>
                            </div>
                          ))
                        ) : (
                          <div className="text-center p-3 text-muted">
                            {headerText.noNotifications}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
              <div
                className="hidden lg:flex px-1  align-items-center mr-auto ml-auto  "
                style={{ cursor: "pointer", marginTop: "4px" }}
              >
                <img
                  className=" hidden xsm:block "
                  src={require("../components/image/interneticon.png")}
                  alt="logo"
                  width="28px"
                  style={{
                    width: "25px",
                    height: "25px",
                    marginRight: "-10px",
                  }}
                />
                <select
                  id="language-select"
                  className=" text-left text-[18px] min-w-[150px] xsm:min-w-[50px] font-[700] lg:font-[400] max-w-[150px] xsm:max-w-[120px] custom-language-select text-white form-select p-0 pr-3  bg-transparent border-0 focus-visible:border-0 focus:ring-0 focus-visible:outline-0"
                  value={selectedLanguage}
                  onChange={(e) => {
                    handleLanguageChange(e);
                  }}
                >
                  {[
                    { code: "en", name: "english" },
                    { code: "fr", name: "francais" },
                    { code: "de", name: "deutsch" },
                    { code: "it", name: "italiano" },
                    { code: "es", name: "español" },
                    { code: "jp", name: "nihongo" },
                    { code: "nl", name: "nederlands" },
                    { code: "zh", name: "chinese" },
                  ].map((lang) => (
                    <option key={lang.code} value={lang.name}>
                      {lang.code.toUpperCase()}
                    </option>
                  ))}
                </select>
              </div>

              {auth?.user && (
                <>
                  <div
                    className="px-0 hidden lg:block"
                    style={{ cursor: "pointer" }}
                  >
                    <Dropdown className="dropclnrt2">
                      <Dropdown.Toggle as="div">
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            backgroundColor: "#f3f4f6",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                            <img
                              src={
                                profileImage
                                ? profileImage?.startsWith("http")
                                  ? profileImage
                                  : BASE_URL + "/uploads/" + profileImage
                                  : require("../pages/image/addphotoicon.png")
                              }
                            alt="Profile"
                              width="40px"
                              height="40px"
                              style={{
                                display: "inline-block",
                                width: "40px",
                                height: "40px",
                              objectFit: "cover",
                              }}
                            />
                        </div>
                      </Dropdown.Toggle>
                      <div className="pualpicdrop">
                        <Dropdown.Menu
                          className={`py-2 px-1 dropclnrt2 ${isAdmin ? "admin" : ""
                            }`}
                        >
                          <Dropdown.Item
                            className="fs-6 mt-1 fw-normal text-dark"
                            style={{ lineHeight: "21.79px" }}
                            onClick={() => {
                              // OLD CODE - Future use: Ambassador check for dashboard routing
                              // const storedAuth = JSON.parse(
                              //   localStorage.getItem("auth")
                              // );
                              // const isAmbassador =
                              //   storedAuth?.user?.isAmbassador;
                              // if (isAmbassador) {
                              //   navigate("/leading"); // Ambassador dashboard
                              // } else {
                              //   navigate("/leading"); // Normal user dashboard
                              // }
                              // NEW CODE: All users navigate to /leading (ambassador dashboard)
                              navigate("/leading");
                            }}
                          >
                            {/* Dashboard - Not translated */}
                            Dashboard
                          </Dropdown.Item>

                          <Dropdown.Item
                            className="fs-6 mt-1 fw-normal text-dark"
                            style={{ lineHeight: "21.79px" }}
                            onClick={() => navigate("/profile")}
                          >
                            {/* Settings */}
                            {lg?.setg}
                          </Dropdown.Item>

                          {/* isAdmin true hai to "All List" item show hoga */}
                          {isAdmin && (
                            <Dropdown.Item
                              className="fs-6 mt-1 fw-normal text-dark"
                              style={{ lineHeight: "21.79px" }}
                              onClick={() => navigate("/admindashboard")}
                            >
                              Admin
                            </Dropdown.Item>
                          )}

                          <Dropdown.Item
                            className="fs-6 mt-1 fw-normal text-dark"
                            style={{ lineHeight: "21.79px" }}
                            onClick={handleLogout} //logout handle
                          >
                            {/* Logout */}
                            {lg?.logout}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </div>
                    </Dropdown>
                  </div>
                  <div
                    className="ftznav fw-bold mt-2 block lg:hidden"
                    style={{
                      color: "#FFFFFF",

                      lineHeight: "24.51px",
                      fontSize: "16px",
                    }}
                    onClick={() => navigate("/leading")}
                  >
                    Dashboard
                  </div>
                  <div
                    className="ftznav fw-bold mt-2 block lg:hidden"
                    style={{
                      color: "#FFFFFF",

                      lineHeight: "24.51px",
                      fontSize: "16px",
                    }}
                    onClick={handleLogout} //logout handle
                  >
                    {/* Logout */}
                    {lg?.logout || "Logout"}
                  </div>
                </>
              )}
              <div
                className=" lg:hidden px-1 flex align-items-center mr-auto ml-auto  "
                style={{ cursor: "pointer", marginTop: "4px" }}
              >
                <img
                  className=" hidden xsm:block "
                  src={require("../components/image/interneticon.png")}
                  alt="logo"
                  width="28px"
                  style={{
                    width: "25px",
                    height: "25px",
                    marginRight: "-14px",
                  }}
                />
                <select
                  id="language-select"
                  className=" text-left text-[18px] min-w-[150px] xsm:min-w-[50px] font-[600] lg:font-[400] max-w-[150px] xsm:max-w-[120px] custom-language-select text-white form-select p-0 pr-3  bg-transparent border-0 focus-visible:border-0 focus:ring-0 focus-visible:outline-0"
                  value={selectedLanguage}
                  onChange={(e) => {
                    handleLanguageChange(e);
                  }}
                >
                  {[
                    { code: "en", name: "english", displayName: "english" },
                    { code: "fr", name: "francais", displayName: "francais" },
                    { code: "de", name: "deutsch", displayName: "deutsch" },
                    { code: "it", name: "italiano", displayName: "italiano" },
                    { code: "es", name: "español", displayName: "español" },
                    { code: "jp", name: "nihongo", displayName: "Japanese" },
                    { code: "nl", name: "nederlands", displayName: "nederlands" },
                    { code: "zh", name: "chinese", displayName: "chinese" },
                  ].map((lang) => (
                    <option key={lang.code} value={lang.name}>
                      {lang.displayName}
                    </option>
                  ))}
                </select>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Modal Component */}
      <Modal
        show={false}
        onHide={handleClose}
        centered
        className="d-none custom-modal"
      >
        <Modal.Header className=" border-0">
          <img
            className="d-none border-0 closebtn "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>

        <Modal.Title
          className="text-center text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          {headerText.createAccountTitle}
        </Modal.Title>

        <Modal.Body className="modelbody">
          <div className="text-center">
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal  mt-4 my-1 position-relative modelacc  btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <GoogleOAuthProvider clientId={clientId}>
                <div className="googlelogin ">
                  <GoogleLogin
                    onSuccess={handleLoginSuccess}
                    onError={() => console.log("Login Failed")}
                  />
                </div>
              </GoogleOAuthProvider>
              <div className="mtgoole" style={{ marginTop: "-40px" }}>
                <img
                  className=" position-absolute lefttt"
                  src={require("../components/image/google.png")}
                  alt="Google"
                />
                {headerText.continueGoogle}
              </div>
            </Button>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4 fw-normal my-1 position-relative  modelacc  btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
              onClick={handleFacebookLogin}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/facebook.png")}
                alt="Facebook"
              />{" "}
              {headerText.continueFacebook}
            </Button>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal my-1 position-relative modelacc   btnhover "
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/apple.png")}
                alt="Apple"
              />
              {headerText.continueApple}
            </Button>

            <Button
              variant="light"
              className="w-100 my-1 rounded-4  fs-5 fw-normal position-relative modelacc    btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
              onClick={handleShowEmail}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/email.png")}
                alt="Email"
              />
              {headerText.continueEmail}
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <div className="text-center w-100">
            <div className="mt-2 mb-3 fs-4 fw-bold modeltitle ">
              {headerText.alreadyMemberQuestion}
            </div>
            <Button
              className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
              style={{
                backgroundColor: "#34C3C9",
                lineHeight: "27.24px",
                color: "#000000",
                maxWidth: "231px",
                height: "44px",
              }}
              onClick={handleLoginShow}
            >
              {headerText.loginCta}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Login Modal */}
      <Modal
        show={false}
        onHide={handleLoginClose}
        centered
        className="custom-modal custom-modallogin"
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleLoginClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center fw-bold modeltitle mt-3"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
            color: "#000000",
          }}
        >
          Login
        </Modal.Title>
        <Modal.Body className="modelbody">
          <div className="text-center">
            <form className="textleft  margg" onSubmit={handleSubmitLogin}>
              <div className="mb-3">
                <label
                  htmlFor="email"
                  className="form-label fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  Email
                </label>
                <input
                  type="email"
                  className="form-control fs-5 ftzevtt rounded-4 placeholder-login"
                  id="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "56px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>
              <div className="mb-3">
                <div className="d-flex  justify-content-between">
                  <label
                    htmlFor="password"
                    className="form-label ftlink fs-5"
                    style={{
                      color: "#000000",
                      lineHeight: "27.24px",
                      fontWeight: "600",
                    }}
                  >
                    Password
                  </label>
                  <label
                    htmlFor="password"
                    className="form-label fontmobil fw-normal "
                    style={{
                      color: "#000000",
                      lineHeight: "24.51px",
                      fontSize: "18px",
                      cursor: "pointer",
                    }}
                    // onClick={() => navigate("/forgot-password")}
                    onClick={handleFPShow}
                  >
                    Forgot Password?
                  </label>
                </div>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control fs-5 ftzevtt rounded-4 placeholder-login"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{
                      border: "1px solid #6D6D6D",
                      maxWidth: "539px",
                      height: "56px",
                      fontWeight: "600",
                      lineHeight: "27.24px",
                      color: "#7B7B7B",
                    }}
                  />
                  <div
                    className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibilityy}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "15px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? (
                      <FaEyeSlash size={20} />
                    ) : (
                      <FaEye size={20} />
                    )}
                  </div>
                </div>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input rounded-0 placeholder-login"
                  type="checkbox"
                  // required
                  defaultValue
                  id="flexCheckDefault"
                  style={{ border: "1px solid #6D6D6D " }}
                />
                <label
                  className="form-check-label fs-6"
                  htmlFor="flexCheckDefault"
                  style={{
                    color: "#4C4C4C",
                    fontWeight: "600",
                    lineHeight: "21.79px",
                  }}
                >
                  Keep me signed in
                </label>
              </div>
              <div className="text-center mt-3">
                <Button
                  type="submit"
                  className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
                  style={{
                    backgroundColor: "#34C3C9",
                    lineHeight: "27.24px",
                    color: "#000000",
                    maxWidth: "231px",
                    height: "44px",
                  }}
                  onClick={handleLoginShow} // Show login modal
                >
                  Login
                </Button>
              </div>

              <div className="d-flex justify-content-center gap-2 mt-4">
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "255px",
                    border: "1.4px solid #969696",

                    height: "1.4px",
                  }}
                ></div>

                <div
                  className="ftzcopy   fs-6 text-center"
                  style={{
                    color: "#595959",

                    fontFamily: "Open Sans",
                    fontWeight: "600",
                    lineHeight: "21.79px",
                    marginTop: "-10px",
                  }}
                >
                  or
                </div>
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "255px",
                    border: "1.4px solid #969696",

                    height: "1.4px",
                  }}
                ></div>
              </div>
            </form>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal mtlow mt-4 my-1 position-relative modelacclogin btnhover"
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            // onClick={handleLoginSuccess}
            >
              <GoogleOAuthProvider clientId={clientId}>
                <div className="googlelogin ">
                  <GoogleLogin
                    onSuccess={handleLoginSuccess}
                    onError={() => console.log("Login Failed")}
                  />
                </div>
              </GoogleOAuthProvider>
              <div className="mtgoole" style={{ marginTop: "-40px" }}>
                <img
                  className=" position-absolute lefttt lefttt22"
                  src={require("../components/image/google.png")}
                  alt="Google"
                />
                {headerText.continueGoogle}
              </div>
            </Button>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal my-1 position-relative modelacclogin btnhover "
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt lefttt22"
                src={require("../components/image/apple.png")}
                alt="Apple"
              />
              {headerText.continueApple}
            </Button>
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4 fw-normal my-1 position-relative modelacclogin btnhover"
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
              onClick={handleFacebookLogin}
            >
              <img
                className=" position-absolute lefttt lefttt22"
                src={require("../components/image/facebook.png")}
                alt="Facebook"
              />
              {headerText.continueFacebook}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {show && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="relative w-full max-w-[560px] rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-black/5 sm:p-8 animate-fadeIn">
            <button
              aria-label="Close"
              onClick={handleClose}
              className="absolute right-4 top-4 rounded-full p-2 text-slate-500 hover:bg-slate-50"
            >
              <X size={18} />
            </button>
            <h1 className="mb-6 text-center text-2xl font-bold tracking-tight text-slate-900">
              {headerText.createAccountTitle}
            </h1>

            <div className="grid gap-3">
              <SocialButton
                icon={<GoogleLogo />}
                label={headerText.continueGoogle}
                onClick={() => login()}
              />
              <FacebookLogin
                appId={1375278530871466}
                fields="name,email,picture"
                callback={handleFacebookResponse}
                render={(renderProps) => (
                  <SocialButton
                    icon={<FacebookLogo />}
                    label={headerText.continueFacebook}
                    onClick={renderProps.onClick}
                  />
                )}
              />

              <SocialButton
                icon={<AppleLogo />}
                label={headerText.continueApple}
              />
            </div>

            <div className="my-6 flex items-center gap-3 text-sm text-slate-500">
              <div className="h-px flex-1 bg-[#eee]" />
              <span>{headerText.orText}</span>
              <div className="h-px flex-1 bg-[#eee]" />
            </div>

            <SocialButton
              onClick={handleShowEmail}
              icon={<Mail size={20} />}
              label={headerText.continueEmail}
              variant="primary"
            />

            <div className="mt-6 text-center text-sm text-slate-700">
              {headerText.alreadyMemberQuestion}{" "}
              <button
                onClick={handleLoginShow}
                className="font-semibold text-[var(--primary)] hover:underline inline-flex items-center gap-1"
                style={{ ["--primary"]: PRIMARY }}
              >
                {headerText.loginCta} <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>
      )}
      {/* SignUp Email Modal */}
      <AnimatePresence>
        {showEmail && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-xl"
            >
              <button
                onClick={handleEmailClose}
                className="absolute top-3 right-3 text-slate-500 hover:text-slate-700"
              >
                ✕
              </button>

              <h2 className="text-2xl font-bold text-center text-slate-800">
                {headerText.signupTitle}
              </h2>
              <p className="mt-1 text-center text-sm text-slate-600">
                {headerText.signupSubtitle}
              </p>

              <form className="mt-6 space-y-4">
                <input
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    validateEmail(e.target.value);
                  }}
                  type="email"
                  placeholder={headerText.emailLabel}
                  className={`w-full rounded-xl border px-3 py-2 text-sm focus:ring-1 ${emailError
                      ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                      : "border-slate-300 focus:border-[#34c3c9] focus:ring-[#34c3c9]"
                    }`}
                />
                {emailError && (
                  <p className="mt-1 text-xs text-red-500">{emailError}</p>
                )}
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder={headerText.nameLabel}
                  className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm focus:border-[#34c3c9] focus:ring-1 focus:ring-[#34c3c9]"
                />
                <label className="text-sm font-medium w-full">
                  {headerText.passwordLabel}
                  <div className="relative mt-1 w-full">
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      type={showPassword ? "text" : "password"}
                      className="w-full rounded-xl border border-[#e5e5e5] bg-white px-3 py-2 pr-9 text-sm outline-none focus:ring-2 focus:ring-[var(--primary)]"
                      placeholder=""
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibilityy}
                      className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-500 hover:bg-slate-50"
                    >
                      {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                    </button>
                  </div>
                </label>

                {/* Bookseller toggle */}
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    {headerText.booksellerQuestion}
                  </label>
                  <div className="flex gap-3">
                    <button
                      type="button"
                      onClick={() => setBookseller(true)}
                      className={`flex-1 rounded-xl border px-3 py-2 text-sm font-medium ${bookseller === true
                          ? "bg-[#34c3c9] text-white border-[#34c3c9]"
                          : "border-slate-300 text-slate-700 hover:bg-slate-50"
                        }`}
                    >
                      {headerText.yesLabel}
                    </button>
                    <button
                      type="button"
                      onClick={() => setBookseller(false)}
                      className={`flex-1 rounded-xl border px-3 py-2 text-sm font-medium ${bookseller === false
                          ? "bg-[#34c3c9] text-white border-[#34c3c9]"
                          : "border-slate-300 text-slate-700 hover:bg-slate-50"
                        }`}
                    >
                      {headerText.noLabel}
                    </button>
                  </div>
                </div>
                {bookseller === true && (
                  <>
                    <div className="mt-2">
                      <input
                        value={storeName}
                        onChange={(e) => setStoreName(e.target.value)}
                        type="text"
                        placeholder={headerText.storeNamePlaceholder}
                        className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm focus:border-[#34c3c9] focus:ring-1 focus:ring-[#34c3c9]"
                      />
                    </div>
                    <div className="mt-2">
                      <input
                        value={storeAddress}
                        onChange={(e) => setStoreAddress(e.target.value)}
                        type="text"
                        placeholder={headerText.addressPlaceholder}
                        className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm focus:border-[#34c3c9] focus:ring-1 focus:ring-[#34c3c9]"
                      />
                    </div>
                  </>
                )}
                <div className="flex items-start gap-2 text-xs text-slate-600">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    id="tos"
                    className="mt-1"
                  />
                  <label htmlFor="tos">
                    {headerText.signupAgreementPrefix}{" "}
                    <Link
                      target="_blank"
                      to="/terms"
                      className="text-[#34c3c9] hover:underline"
                    >
                      {headerText.termsLinkText}
                    </Link>
                    ,{" "}
                    <Link
                      to="/privacy"
                      target="_blank"
                      className="text-[#34c3c9] hover:underline"
                    >
                      {headerText.privacyLinkText}
                    </Link>{" "}
                    {headerText.signupAgreementAnd}{" "}
                    <Link
                      to="/cookies"
                      target="_blank"
                      className="text-[#34c3c9] hover:underline"
                    >
                      {headerText.cookiesLinkText}
                    </Link>
                    .
                  </label>
                </div>

                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="w-full rounded-xl bg-[#34c3c9] px-4 py-2 text-sm font-medium text-white shadow-sm hover:brightness-95"
                >
                  {headerText.signupButtonText}
                </button>
              </form>

              <p className="mt-4 text-center text-sm text-slate-600">
                {headerText.alreadyHaveAccount}
                <span
                  onClick={handleLoginShow}
                  className="ml-[3px] text-[#34c3c9] font-medium hover:underline cursor-pointer"
                >
                  {headerText.loginLinkText}
                </span>
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      {showLogin && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="m-auto relative w-full max-w-[560px] rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-black/5 sm:p-8">
            <button
              aria-label="Close"
              onClick={handleLoginClose}
              className="absolute right-4 top-4 rounded-full p-2 text-slate-500 hover:bg-slate-50"
            >
              <X size={18} />
            </button>

            {/* Header Title */}
            <h1 className="mb-6 text-center text-2xl font-bold tracking-tight text-slate-900">
              {headerText.loginCta}
            </h1>

            <form className="grid gap-3" onSubmit={handleSubmitLogin}>
              <label className="text-sm font-medium">
                {headerText.emailLabel}
                <input
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  type="email"
                  className="mt-1 w-full rounded-xl border border-[#e5e5e5] bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[var(--primary)]"
                  placeholder={headerText.emailLabel}
                />
              </label>
              <label className="text-sm font-medium">
                {headerText.passwordLabel}
                <div className="relative mt-1">
                  <input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    type={showPassword ? "text" : "password"}
                    className="w-full rounded-xl border border-[#e5e5e5] bg-white px-3 py-2 pr-9 text-sm outline-none focus:ring-2 focus:ring-[var(--primary)]"
                    placeholder=""
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibilityy}
                    className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-500 hover:bg-slate-50"
                  >
                    {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                  </button>
                </div>
              </label>

              <div className="flex items-center justify-between text-sm">
                <label className="inline-flex items-center gap-2">
                  <input type="checkbox" className="rounded border-[#dcdcdc]" />
                  <span>{headerText.keepSignedIn}</span>
                </label>
                <button
                  type="button"
                  className="text-[var(--primary)] hover:underline"
                  style={{ ["--primary"]: PRIMARY }}
                  onClick={() => {
                    setShowLogin(false);
                    setShowForgot(true);
                  }}
                >
                  {headerText.forgotPassword}
                </button>
              </div>

              <button
                onClick={handleLoginShow}
                type="submit"
                className="mt-1 rounded-xl bg-[var(--primary)] px-4 py-2.5 text-sm font-semibold text-white hover:brightness-95"
                style={{ ["--primary"]: PRIMARY }}
              >
                {headerText.loginCta}
              </button>
            </form>
          </div>
        </div>
      )}
      {showForgot && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="m-auto relative w-full max-w-[560px] rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-black/5 sm:p-8">
            <button
              aria-label="Close"
              onClick={handleLoginClose}
              className="absolute right-4 top-4 rounded-full p-2 text-slate-500 hover:bg-slate-50"
            >
              <X size={18} />
            </button>

            {/* Header Title */}
            <h1 className="mb-6 text-center text-2xl font-bold tracking-tight text-slate-900">
              {headerText.forgotPasswordTitle}
            </h1>
            <p className="mb-6 text-center text-sm text-slate-500">
              {headerText.forgotPasswordSubtitle}
            </p>
            <form className="space-y-5">
              <div className="relative">
                <label
                  htmlFor="email"
                  className="mb-1 block text-sm font-medium text-slate-600"
                >
                  {headerText.emailLabel}
                </label>
                <div className="relative">
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={headerText.emailLabel}
                    className="w-full rounded-xl border border-slate-300 px-4 py-2.5 text-sm shadow-sm focus:border-[${PRIMARY}] focus:outline-none focus:ring-1 focus:ring-[${PRIMARY}]"
                  />
                  <Mail
                    className="absolute right-3 top-3.5 text-slate-400"
                    size={18}
                  />
                </div>
              </div>

              {/* Submit button */}
              <button
                type="submit"
                onClick={handleForgotPassword}
                className="mt-2 w-full rounded-xl bg-[#34C3C9] py-2.5 text-sm font-semibold text-white shadow-md transition hover:brightness-95"
              >
                {headerText.resetPasswordButton}
              </button>
            </form>
          </div>
        </div>
      )}

      <Modal
        show={false}
        onHide={handleEmailClose}
        centered
        className=" custom-modal custom-modalsign modelaginsignup "
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn closbtnagsig top-0 "
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleEmailClose}
            style={{ marginTop: "32px" }}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center fw-bold  modeltitle  modeltitagsign"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
            color: "#000000",
            marginTop: "-15px",
          }}
        >
          {headerText.signupTitle}
        </Modal.Title>
        <Modal.Body className="modelbody pb-md-0 pt-2 pb-0">
          <div className="text-center">
            <form className="textleft margg" onSubmit={handleSubmit}>
              <div className="mb-2">
                <label
                  htmlFor="email"
                  className="form-label mb-1 fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  {headerText.emailLabel}
                </label>
                <input
                  type="email"
                  className="form-control w-100 rounded-0 ftzevtt fs-5 placeholder-login"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "45px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              <div className="mb-2">
                <label
                  htmlFor="name"
                  className="form-label mb-1 fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  {headerText.nameLabel}
                </label>
                <input
                  type="text"
                  className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "45px",
                    fontWeight: "600",
                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              <div className="mb-2">
                <label
                  htmlFor="password"
                  className="form-label mb-1 fs-5 ftlink"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  {headerText.passwordLabel}
                </label>
                <div
                  className="position-relative"
                  style={{ maxWidth: "539px" }}
                >
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control w-100 rounded-0 px-4 ftzevtt fs-5 placeholder-login"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    placeholder=""
                    style={{
                      border: "1px solid #6D6D6D",
                      maxWidth: "539px",
                      height: "45px",
                      fontWeight: "600",
                      lineHeight: "27.24px",
                      color: "#7B7B7B",
                    }}
                  />
                  <div
                    className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibilityy}
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                  >
                    {showPassword ? (
                      <FaEyeSlash size={20} />
                    ) : (
                      <FaEye size={20} />
                    )}
                  </div>
                  <div
                    className="tooltip-container mt-2 ms-2"
                    style={{ position: "absolute", top: "6px", right: "-25px" }}
                  >
                    <span
                      className=""
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <BsQuestionCircleFill size={20} />
                    </span>
                    <div className="custom-tooltip">
                      {headerText.tooltipPassword}
                    </div>
                  </div>
                </div>
              </div>

              <div className=" mx-auto " style={{ marginBottom: "10px" }}>
                <div
                  className="mt-2 fs-5 d-flex justify-content-center"
                  style={{ color: "black", textAlign: "center" }}
                >
                  {headerText.booksellerQuestion}
                </div>
                <div className="d-flex mt-3 justify-content-center align-items-center gap-3 ">
                  <div
                    className="border border-dark p-1 w-100"
                    style={{ maxWidth: "90px" }}
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2 fs-4 text-dark  ">
                      {headerText.yesLabel}
                      <input
                        type="radio"
                        value="Yes"
                        checked={isBookseller === "Yes"}
                        onChange={() => setIsBookseller("Yes")}
                        className="mt-1"
                        style={{ width: "20px", height: "20px" }}
                      />{" "}
                    </div>
                  </div>
                  <div
                    className="border border-dark p-1 w-100"
                    style={{ maxWidth: "90px" }}
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2 fs-4 text-dark  ">
                      {headerText.noLabel}
                      <input
                        type="radio"
                        value="No"
                        checked={isBookseller === "No"}
                        onChange={() => setIsBookseller("No")}
                        className="mt-1"
                        style={{ width: "20px", height: "20px" }}
                      />{" "}
                    </div>
                  </div>
                </div>
              </div>

              {isBookseller === "Yes" && (
                <>
                  <div className="mt-2">
                    <input
                      type="text"
                      placeholder={headerText.storeNamePlaceholder}
                      className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                      id="name"
                      value={storeName}
                      onChange={(e) => setStoreName(e.target.value)}
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        maxWidth: "539px",
                        height: "45px",
                        fontWeight: "600",
                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>

                  <div className="my-2">
                    <input
                      type="text"
                      placeholder={headerText.addressPlaceholder}
                      className="form-control w-100 ftzevtt fs-5 rounded-0 placeholder-login"
                      id="name"
                      value={storeAddress}
                      onChange={(e) => setStoreAddress(e.target.value)}
                      required
                      style={{
                        border: "1px solid #6D6D6D",
                        maxWidth: "539px",
                        height: "45px",
                        fontWeight: "600",
                        lineHeight: "27.24px",
                        color: "#7B7B7B",
                      }}
                    />
                  </div>
                </>
              )}
              <div className="text-center mt-3 mb-2">
                <Button
                  className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
                  type="submit"
                  style={{
                    backgroundColor: "#34C3C9",
                    lineHeight: "27.24px",
                    color: "#000000",
                    maxWidth: "231px",
                    height: "44px",
                  }}
                  onClick={handleSubmit}
                >
                  {headerText.signupButtonText}
                </Button>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input rounded-0 placeholder-login"
                  type="checkbox"
                  required
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  // defaultValue
                  id="flexCheckDefaultsigup"
                  style={{ border: "1px solid #6D6D6D ", marginTop: "-0px" }}
                />
                <label
                  className="form-check-label  text-center"
                  htmlFor="flexCheckDefaultsigup"
                  style={{
                    color: "#4C4C4C",
                    fontWeight: "600",
                    fontSize: "15.5px",
                    lineHeight: "21.79px",
                    marginTop: "-2px",
                    marginLeft: "-3px",
                  }}
                >
                  {headerText.signupAgreementPrefix}{" "}
                  <span
                    style={{ color: "#EF0707", cursor: "pointer" }}
                    onClick={() => navigate("/terms")}
                  >
                    {headerText.termsLinkText}
                  </span>
                  ,
                  <span
                    style={{ color: "#E33629", cursor: "pointer" }}
                    onClick={() => navigate("/privacy")}
                  >
                    {" "}
                    {headerText.privacyLinkText}{" "}
                  </span>
                  {headerText.signupAgreementAnd}{" "}
                  <span
                    style={{ color: "#E33629", cursor: "pointer" }}
                    onClick={() => navigate("/cookies")}
                  >
                    {" "}
                    {headerText.cookiesLinkText}
                  </span>
                </label>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 py-0">
          <div className="text-center  mt-md-2 w-100">
            <div
              className="text-center fw600 fs-6  "
              style={{
                color: "#4C4C4C",

                lineHeight: "10.79px",
              }}
            >
              {headerText.alreadyHaveAccount}{" "}
              <span
                className="cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={handleLoginShow}
              >
                {headerText.loginLinkText}
              </span>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal ForGetPassword Component */}
      <Modal
        show={false}
        onHide={handleFClose}
        centered
        className="custom-modal custom-modalhegit "
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn  closebtnchpas"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleFClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          {headerText.resetPasswordTitle}
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <form className="textleft margg mt-3" onSubmit={handleSubmitForget}>
            {/* <div className="mb-3">
              <label
                htmlFor="cpassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                Current Password
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="cpassword"
                  style={{ border: "0.1px " }}
                />

                <img
                  className="m-3"
                  src={require("../pages/image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordVisibility}
                />
                <i
                  className={`bi ${
                    passwordVisible ? "bi-eye" : "bi-eye-slash"
                  }`}
                ></i>
              </div>
            </div> */}

            <div
              className=" mb-4"
              style={{
                color: "#4C4C4C",
                fontWeight: "600",
                fontSize: "15.5px",
                lineHeight: "21.79px",
                marginTop: "-2px",
                marginLeft: "-3px",
              }}
            >
              {headerText.passwordGuidelines}
            </div>

            <div className="mb-3">
              <label
                htmlFor="npassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                {headerText.newPasswordLabel}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 ftzevtt outline-none  rounded-4 placeholder-login"
                  id="npassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  style={{ border: "0.1px " }}
                  required
                />

                <img
                  className="m-3"
                  src={require("../pages/image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordNewVisibility}
                />
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="cnpassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                {headerText.confirmNewPasswordLabel}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 ftzevtt outline-none  rounded-4 placeholder-login"
                  id="cnpassword"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  style={{ border: "0.1px " }}
                  required
                />

                <img
                  className="m-3"
                  src={require("../pages/image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordNewVisibility}
                />
              </div>
            </div>
          </form>
          <div className="mt-4 text-center">
            <button
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "167px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
              onClick={handleSubmitForget}
            >
              {headerText.submitButton}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* SEnd EMAIL FOR FORGET PASSWORD */}

      <Modal
        show={false}
        onHide={handleFPClose}
        centered
        className="custom-modal custom-modalhegit modalforget "
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn  closebtnchpas"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleFPClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          {headerText.forgotPasswordTitle}
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <form className="textleft margg mt-3" onSubmit={handleForgotPassword}>
            <div
              className=" mt-4 mb-5"
              style={{
                color: "black",
                fontWeight: "600",
                fontSize: "20px",
                lineHeight: "21.79px",
                marginTop: "-2px",
                marginLeft: "-3px",
              }}
            >
              {headerText.forgotPasswordSubtitle}
            </div>
            <div className="mb-3">
              <label
                htmlFor="cnpassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                {headerText.emailLabel}
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type="email"
                  className="form-control w-100 fs-5 ftzevtt outline-none  rounded-4 placeholder-login"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ border: "0.1px " }}
                />
              </div>
            </div>
          </form>
          <div className="mt-5 text-center">
            <button
              type="submit"
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "195px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
              onClick={handleForgotPassword}
            >
              {headerText.resetPasswordButton}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* LangUage Change IP */}

    </>
  );
};

export default Header3;
